import {
  CONNECTION_NAME,
  CREATED_BY,
  DATE_RANGE,
  QUOTE_DATE,
  QUOTE_AMOUNT,
  QUOTE_STATUS,
  QUOTE_VALID_UNTIL,
  QUOTE_WORK_ORDER,
} from "~/constants/filters/filters";

const defaultQuoteFilters = {
  [QUOTE_STATUS]: [],
  [CONNECTION_NAME]: [],
  [QUOTE_DATE]: [],
  [DATE_RANGE]: [],
  [QUOTE_AMOUNT]: [],
  [QUOTE_VALID_UNTIL]: [],
  [CREATED_BY]: [],
};

const pickFilter = (
  activeFilters: Record<string, unknown>,
  key: string,
): unknown[] | undefined => {
  const value = activeFilters[key];
  if (!Array.isArray(value) || value.length === 0) return undefined;
  return value;
};

const toIsoDateRange = (dates: unknown[]) => {
  if (!Array.isArray(dates) || dates.length < 2) return undefined;
  const start = new Date(dates[0] as string | Date).toISOString();
  const end = new Date(dates[1] as string | Date).toISOString();
  return [start, end];
};

export const buildFinanceQuotesWhere = (
  activeFilters: Record<string, unknown> = defaultQuoteFilters,
  searchQuery?: string,
) => {
  const status_in = pickFilter(activeFilters, QUOTE_STATUS) as
    | string[]
    | undefined;
  const company_in = pickFilter(activeFilters, CONNECTION_NAME) as
    | string[]
    | undefined;
  const workOrder_in = pickFilter(activeFilters, QUOTE_WORK_ORDER) as
    | string[]
    | undefined;
  const date = toIsoDateRange(
    (pickFilter(activeFilters, QUOTE_DATE) as unknown[]) ??
      (pickFilter(activeFilters, DATE_RANGE) as unknown[]) ??
      [],
  );
  const amountRaw = pickFilter(activeFilters, QUOTE_AMOUNT);
  const validUntilDate = toIsoDateRange(
    (pickFilter(activeFilters, QUOTE_VALID_UNTIL) as unknown[]) ?? [],
  );
  const createdBy_in = pickFilter(activeFilters, CREATED_BY) as
    | string[]
    | undefined;

  let amount: (number | null)[] | undefined;
  if (Array.isArray(amountRaw) && amountRaw.length) {
    const min =
      amountRaw[0] === "" || amountRaw[0] == null ? null : Number(amountRaw[0]);
    const max =
      amountRaw[1] === "" || amountRaw[1] == null
        ? undefined
        : Number(amountRaw[1]);
    amount = max !== undefined ? [min ?? 0, max] : [min ?? 0];
  }

  return {
    ...(searchQuery?.trim() ? { searchQuery: searchQuery.trim() } : {}),
    ...(status_in ? { status_in } : {}),
    ...(company_in ? { company_in } : {}),
    ...(workOrder_in ? { workOrder_in } : {}),
    ...(date ? { date } : {}),
    ...(amount ? { amount } : {}),
    ...(validUntilDate ? { validUntilDate } : {}),
    ...(createdBy_in ? { createdBy_in } : {}),
  };
};

export const buildListFinanceQuotesVariables = ({
  activeFilters,
  searchQuery,
  limit,
  skip,
  sort = ["created_at:desc"],
}: {
  activeFilters?: Record<string, unknown>;
  searchQuery?: string;
  limit: number;
  skip: number;
  sort?: string[];
}) => ({
  params: {
    limit,
    skip,
    sort,
    where: buildFinanceQuotesWhere(activeFilters, searchQuery),
  },
});
